/*
 * Back number artwork (Vogntrøje): the shop's own numerals from the print file
 * (one transparent image per digit, mesh and student cap included; the holes
 * let the fabric show through). The model's backNumber slot names the images
 * ({ url: '…/{digit}.webp', gap }); any 1–2 digit number, a leading zero is kept.
 */

/** '0'–'99' as typed (leading zero kept); null for anything else. */
export function normalizeJerseyNumber(value) {
  const digits = String(value ?? '').trim();
  return /^\d{1,2}$/.test(digits) ? digits : null;
}

/** Image URL of one digit: digits.url with {digit} filled in. */
export const jerseyDigitUrl = (digits, digit) => digits.url.replace('{digit}', digit);
